import React from "react";
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ReschedulingApprovalPopup from "./ReschedulingApprovalPopup";
import { prepareLocalStateReScheduleToSaveBackend } from "../planner/virtualTripHelpers";

const SaveChangesPanel = ({ onSave, onReset, setReschedulePopupState, reschedulePopupState, rescheduleReason, setLoading, loading }: any) => {
  const classes = useStyles();

  const openReschedulePopup = () => {
    const modelData = prepareLocalStateReScheduleToSaveBackend()
    if(modelData.length > 0){
      setReschedulePopupState(true);
    }
    else{
      onSave();
    }
    
  };
  const closeReschedulePopup = async () => {
    setReschedulePopupState(false);
  };

  return (
    <div className={classes.root}>
      <div className={classes.text}>
        <span className={classes.mainText}>You've made scheduling changes</span>
        <span className={classes.subText}>
          Vehicle(s) will be notifed of updates when you save your changes
        </span>
      </div>
      <div className={classes.actionButtons}>
        <Button
          variant="outlined"
          onClick={onReset}
          className={classes.resetButton}
          disableRipple
          disableTouchRipple
        >
          Reset
        </Button>
        <Button
          variant="outlined"
          className={classes.saveButton}
          disableRipple
          disableTouchRipple
          onClick={() => {
            openReschedulePopup();
          }}
        >
          Save Changes
        </Button>
      </div>
      <ReschedulingApprovalPopup
        open={reschedulePopupState}
        onClose={closeReschedulePopup}
        onSave = {onSave}
        rescheduleReason = {rescheduleReason}
        setLoading = {setLoading}
        loading = {loading}
        onReset = {onReset}
      />
    </div>
  );
};

export default SaveChangesPanel;

const useStyles = makeStyles({
  root: {
    background: "#F4B827",
    display: "flex",
    height: 64,
    position: "fixed",
    zIndex: 1297,
    bottom: 0,
    left: 0,
    right: 0,
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
  },
  text: {
    fontFamily: "Lato",
    fontSize: "16px",
    lineHeight: "19px",
    color: "#00152E",
  },
  mainText: {
    fontWeight: 900,
    marginLeft: "32px",
  },
  subText: {
    fontWeight: 400,
    marginLeft: "27px",
  },
  actionButtons: {
    marginRight: "28px",
    display: "flex",
  },
  resetButton: {
    padding: "3px",
    color: "#02489D",
    backgroundColor: "transparent !important",
    borderColor: "transparent",
    fontSize: "14px",
    lineHeight: "17px",
    height: "35px",
    borderRadius: "0",
    marginRight: "54px !important",
    minWidth: "unset",
  },
  saveButton: {
    padding: "8px 20px 10px",
    color: "#fff",
    backgroundColor: "#02489D !important",
    borderColor: "#02489D",
    fontSize: "14px",
    lineHeight: "17px",
    height: "35px",
    borderRadius: "4px",
    minWidth: "unset",
  },
});
